import { createAction } from '@reduxjs/toolkit';

export const twitchUpdateId = createAction('twitch/updateId');
export const twitchUpdateUID = createAction('twitch/updateUID');
export const twitchUpdateSID = createAction('twitch/updateSid');
export const twitchUpdateIsAdded = createAction('twitch/updateIsAdded');
export const twitchUpdateIsActive = createAction('twitch/updateIsActive');

export const twitchStore = createAction('twitch/store');
export const twitchClear = createAction('twitch/clear');

export const twitchUpdateRequest = createAction('twitch/updateRequest');
export const twitchUpdateError = createAction('twitch/updateError');
export const twitchUpdateStore = createAction('twitch/updateStore');

export const twitchUpdateUrl = createAction('twitch/updateUrl');
export const twitchUpdateDisplay = createAction('twitch/updateDisplay');

export const twitchUpdateHeadingTitle = createAction('twitch/updateHeadingTitle');
export const twitchUpdateHeadingDescription = createAction('twitch/updateHeadingDescription');
export const twitchUpdateHeadingTextAlign = createAction('twitch/updateHeadingTextAlign');
export const twitchUpdateHeadingImage = createAction('twitch/updateHeadingImage');
export const twitchUpdateHeadingDivider = createAction('twitch/updateHeadingDivider');

export const twitchUpdateSectionIsBackground = createAction('twitch/updateSectionIsBackground');
export const twitchUpdateSectionTextColor = createAction('twitch/updateSectionTextColor');
export const twitchUpdateSectionBackgroundColor = createAction('twitch/updateSectionBackgroundColor');
export const twitchUpdateSectionOpacity = createAction('twitch/updateSectionOpacity');
export const twitchUpdateSectionIsFullWidth = createAction('twitch/updateSectionIsFullWidth');
export const twitchUpdateSectionShadow = createAction('twitch/updateSectionShadow');
export const twitchUpdateSectionShadowColor = createAction('twitch/updateSectionShadowColor');
export const twitchUpdateSectionPadding = createAction('twitch/updateSectionPadding');
export const twitchUpdateSectionMargin = createAction('twitch/updateSectionMargin');
export const twitchUpdateSectionBackgroundType = createAction('twitch/updateSectionBackgroundType');
export const twitchUpdateSectionBackgroundImage = createAction('twitch/updateSectionBackgroundImage');
export const twitchUpdateSectionGradientColor1 = createAction('twitch/updateSectionGradientColor1');
export const twitchUpdateSectionGradientColor2 = createAction('twitch/updateSectionGradientColor2');
export const twitchUpdateSectionGradientDirection = createAction('twitch/updateSectionGradientDirection');
export const twitchUpdateSectionGradientOffset = createAction('twitch/updateSectionGradientOffset');
export const twitchUpdateSectionBorder = createAction('twitch/updateSectionBorder');
export const twitchUpdateSectionBorderColor = createAction('twitch/updateSectionBorderColor');
export const twitchUpdateSectionShadowBorderColor = createAction('twitch/updateSectionShadowBorderColor');
export const twitchUpdateSectionShape = createAction('twitch/updateSectionShape');
